<template>
    <div id="salons-list">
        <Message :message="editMessage" type="warning" v-if="editMessage !==''"></Message>
        <Message :message="message" :type="type" v-if="message !== ''"></Message>
        <h2 class="title">{{$t('salons.title')}}</h2>
        <div class="content">
            <div class="controls" v-if="loaded">
                <div class="buttons">
                    <div class="adds">
                        <div class="add-link">

                            <button @click.prevent="addOne" href="/">
                                <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
                                {{$t('salons.addOne')}}
                            </button>
                        </div>
                        <div class="add-link">

                            <button @click.prevent="addTen" href="/">
                                <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
                                {{$t('salons.addTen')}}
                            </button>
                        </div>
                    </div>
                    <div class="ops">
                        <SubmitButton :class="{'validation-error': editMode > 0}"
                                      @save="saveChanges"></SubmitButton>
                        <CancelButton @cancel="cancel"></CancelButton>
                    </div>
                </div>
                <div class="search-container">
                    <input :placeholder="$t('salons.search')" @blur="magic_flag = false"
                           @focus="magic_flag = true"
                           type="text"
                           v-model="search"/>
                </div>
            </div>
            <div class="paging" v-if="salons.length > size">
                <pager :init-page="pageNumber+1"
                       :show-jump="false"
                       :text-next="$t('pager.nextPage')"
                       :text-previous="$t('pager.previousPage')"
                       :total-page="pageCount"
                       @go-page="goPage"
                >
                </pager>
            </div>
            <div :key="dataKey" class="table-container">
                <div class="table">
                    <div class="tr" v-if="loaded">
                        <span class="td">{{$t('general.number-order')}}</span>
                        <span @click="sort('name')" class="td">
                            <div class="sortable-column">
                                {{$t('salons.name')}}
                                <div class="sort-operations">
                                    <font-awesome-icon icon="sort"
                                                       v-if="currentSort !== 'name'">
                                    </font-awesome-icon>
                                    <div v-else>
                                        <font-awesome-icon icon="caret-down" v-if="currentSortDir==='desc'">
                                        </font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else>
                            </font-awesome-icon>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span @click="sort('sid')" class="td"><div class="sortable-column">
                            SID
                              <div class="sort-operations">

                            <font-awesome-icon icon="sort"
                                               v-if="currentSort !== 'sid'"></font-awesome-icon><div
                                      v-else>
                            <font-awesome-icon icon="caret-down"
                                               v-if="currentSortDir==='desc'"></font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else></font-awesome-icon>
                              </div>
                        </div>
                        </div></span>
                        <span class="td">{{$t('salons.phone')}}</span>
                        <span class="td">{{$t('salons.lat')}}</span>
                        <span class="td">{{$t('salons.lng')}}</span>
                        <span @click="sort('supervisor')" class="td">
                            <div class="sortable-column">
                                {{$t('salons.supervisor')}}
                                <div class="sort-operations">
                                    <font-awesome-icon icon="sort"
                                                       v-if="currentSort !== 'supervisor'">
                                    </font-awesome-icon>
                                    <div v-else>
                                        <font-awesome-icon icon="caret-down" v-if="currentSortDir==='desc'">
                                        </font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else>
                            </font-awesome-icon>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span class="td">{{$t('salons.street')}}</span>
                        <span @click="sort('city')" class="td">
                            <div class="sortable-column">
                                {{$t('salons.city')}}
                                <div class="sort-operations">
                                    <font-awesome-icon icon="sort"
                                                       v-if="currentSort !== 'city'">
                                    </font-awesome-icon>
                                    <div v-else>
                                        <font-awesome-icon icon="caret-down" v-if="currentSortDir==='desc'">
                                        </font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else>
                            </font-awesome-icon>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span @click="sort('postalCode')" class="td">
                            <div class="sortable-column">
                                {{$t('salons.postal')}}
                                <div class="sort-operations">
                                    <font-awesome-icon icon="sort"
                                                       v-if="currentSort !== 'postalCode'">
                                    </font-awesome-icon>
                                    <div v-else>
                                        <font-awesome-icon icon="caret-down" v-if="currentSortDir==='desc'">
                                        </font-awesome-icon>
                            <font-awesome-icon icon="caret-up" v-else>
                            </font-awesome-icon>
                                    </div>
                                </div>
                            </div>
                        </span>
                        <span class="td">{{$t('salons.groups')}}</span>
                        <span class="td">{{$t('general.operations')}}</span>
                        <span class="td"> </span>
                    </div>
                    <Salon :index="index+1"
                           :key="salon.id"
                           :salon="salon" @delete="deleteSalon"
                           @editModeOff="editModeOff" @editModeOn="editMode += 1"
                           @edited="moveToEdited"
                           @removal="removalHandler"
                           v-for="(salon,index) in paginatedSalons"
                           v-if="loaded">
                    </Salon>
                    <Preloader v-if="!loaded"></Preloader>
                </div>
            </div>
            <div class="paging" v-if="salons.length > size">
                <pager :init-page="pageNumber+1"
                       :show-jump="false"
                       :text-next="$t('pager.nextPage')"
                       :text-previous="$t('pager.previousPage')"
                       :total-page="pageCount"
                       @go-page="goPage"
                >
                </pager>
            </div>
        </div>

    </div>
</template>

<script>
import pager from 'vue-simple-pager';
import Preloader from '@/components/helpers/Preloader.vue';
import Salon from '@/components/salon/Salon.vue';
import { RepositoryFactory } from '@/api/RepositoryFactory';
import Message from '@/components/helpers/Message.vue';
import SubmitButton from '@/components/helpers/SubmitButton.vue';
import CancelButton from '@/components/helpers/CancelButton.vue';
import SalonDTO from '@/DTOs/SalonDTO';

const SalonsRepository = RepositoryFactory.get('salons');

export default {
  name: 'Salons',
  components: {
    Message,
    Salon,
    Preloader,
    CancelButton,
    SubmitButton,
    pager,
  },
  data() {
    return {
      dataKey: 0,
      loaded: true,
      search: '',
      currentSort: 'name',
      currentSortDir: 'asc',
      message: '',
      type: 'info',
      newSalons: [],
      deleteShopIds: [],
      size: 50,
      pageNumber: 0,
      editedSalons: [],
      dummyId: -1,
      existingSalons: [],
      editMode: 0,
      // salons: [],
    };
  },
  watch: {
    async group() {
      await this.getSalons();
    },
    filteredSalons() {
      this.dataKey = this.dataKey + 1;
    },
  },
  async mounted() {
    await this.getSalons();
  },
  methods: {
    goPage(data) {
      this.pageNumber = data.page - 1;
    },
    editModeOff() {
      if (this.editMode - 1 < 0) {
        this.editMode = 0;
      } else {
        this.editMode -= 1;
      }
    },
    deleteSalon(key) {
      const index = this.newSalons.findIndex(salon => salon.id === key);
      this.newSalons.splice(index, 1);
    },
    moveToEdited(salon) {
      if (!this.editedSalons.includes(salon)) {
        const index = this.existingSalons.findIndex(existing => existing.id === salon.id);
        this.existingSalons.splice(index, 1);
        salon.editMode = true;
        salon.edited = true;
        this.editedSalons.push(salon);
        window.scroll(0, 0);
        this.pageNumber = 0;
      }
    },
    nextPage() {
      if (this.pageNumber + 1 > this.pageCount) {
        this.pageNumber = this.pageCount - 1;
        window.scroll(0, 0);
      } else {
        this.pageNumber++;
        window.scroll(0, 0);
      }
    },
    prevPage() {
      this.pageNumber--;
      window.scroll(0, 0);
    },
    removalHandler(id) {
      if (this.deleteShopIds.includes(id)) {
        this.deleteShopIds.splice(this.deleteShopIds.indexOf(id), 1);
      } else {
        this.deleteShopIds.push(id);
      }
    },
    async saveChanges() {
      if (this.editMode <= 0) {
        this.loaded = false;
        this.message = this.$t('messages.genericWait');
        this.type = 'warning';
        const data = {
          groupId: this.$store.getters.selectedGroup.id,
          shops: [],
          deleteShopIds: this.deleteShopIds || null,
        };
        const { salons } = this;
        this.deleteShopIds.forEach((v) => {
          const index = salons.findIndex(salon => salon.id === v);
          if (index > -1) {
            salons.splice(index, 1);
          }
        });
        this.newSalons.forEach((v) => {
          const salon = new SalonDTO(v);
          data.shops.push(salon);
        });
        this.editedSalons.forEach((v) => {
          const sensors = [];
          v.sensors.forEach((sensor) => {
            const s = sensor;
            delete (s.lastActivation);
            sensors.push(s);
          });
          const salon = new SalonDTO(v);
          data.shops.push(salon);
        });
        // console.log(data);
        const { token } = this.$store.getters;
        SalonsRepository.shopsCrud(token, data).then(async (response) => {
          if (response.code === 'OK') {
            await this.getSalons();
            this.newSalons = [];
            this.editedSalons = [];
            this.message = this.$t('messages.genericSave');
            this.type = 'info';
            this.dataKey = this.dataKey + 1;
            this.loaded = true;
          } else {
            this.message = 'Wystąpił błąd';
            this.type = 'error';
            this.dataKey = this.dataKey + 1;
            this.loaded = true;
          }
        });
      }
    },
    async getSalons() {
      this.loaded = false;
      const { token } = this.$store.getters;
      if (this.$store.getters.isAdmin) {
        try {
          const existingSalons = await SalonsRepository.getShopsGroup(token, '');
          await this.$store.dispatch('setSalons', existingSalons);
          this.existingSalons = existingSalons;
        } catch (e) {
          this.message = 'Wystąpił błąd';
          this.type = 'error';
        }
      } else {
        try {
          const existingSalons = await SalonsRepository.getShopsGroup(token, this.$store.getters.selectedGroup.id);
          await this.$store.dispatch('setSalons', existingSalons);
          this.existingSalons = existingSalons;
        } catch (e) {
          this.message = 'Wystąpił błąd';
          this.type = 'error';
        }
      }
      this.existingSalons.forEach((salon) => {
        salon.editMode = false;
      });
      this.loaded = true;
    },
    async cancel() {
      this.loaded = false;
      this.newSalons = [];
      this.editedSalons = [];
      this.editMode = 0;
      await this.getSalons();
      this.message = this.$t('messages.genericCancel');
    },
    addOne() {
      this.newSalons.unshift({
        id: this.dummyId,
        name: '',
        sid: '',
        phone: '',
        supervisor: '',
        address: '',
        sensors: [],
        sensorIdsToDetach: [],
        groups: [],
        editMode: true,
      });
      this.dummyId -= 1;
      this.editMode += 1;
      this.pageNumber = 0;
    },
    addTen() {
      let i = 0;
      for (i = 0; i < 10; i++) {
        this.newSalons.unshift({
          id: this.dummyId,
          name: '',
          sid: '',
          phone: '',
          supervisor: '',
          address: '',
          sensors: [],
          sensorIdsToDetach: [],
          groups: [],
          editMode: true,
        });
        this.dummyId -= 1;
        this.editMode += 10;
        this.pageNumber = 0;
      }
    },
    sort(s) {
      // console.log(s);
      this.dataKey = this.dataKey + 1;
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
      }
      this.currentSort = s;
    },
  },
  computed: {
    editMessage() {
      if (this.editMode > 0) {
        return this.$t('messages.editMode');
      }
      return '';
    },
    paginatedSalons() {
      const start = this.pageNumber * this.size;
      const end = start + this.size;
      return this.salons.slice(start, end);
    },
    pageCount() {
      const l = this.salons.length;
      const s = this.size;
      return Math.ceil(l / s);
    },
    group() {
      return this.$store.getters.selectedGroup.id;
    },
    salons() {
      return [...this.newSalons, ...this.editedSalons, ...this.filteredSalons];
    },
    filteredSalons() {
      return this.sortedSalons.filter(salon => salon.name.toLowerCase().includes((this.search.toLowerCase())));
    },
    sortedSalons() {
      return this.existingSalons.sort((a, b) => {
        let modifier = 1;
        if (this.currentSortDir === 'desc') {
          modifier = -1;
        }
        if (b[this.currentSort] === a[this.currentSort]) {
          return 0;
        }
        if (a[this.currentSort] === null) {
          return -1 * modifier;
        }
        if (b[this.currentSort] === null) {
          return modifier;
        }

        return modifier * a[this.currentSort].toString().toLowerCase().localeCompare(b[this.currentSort].toString().toLowerCase());
      });
    },
  },
};
</script>

<style lang="scss" scoped>
    .sortable-column {
        display: flex;
        justify-content: center;
    }

    #salons-list {
        /*width: 1510px;*/
        margin: 0 auto;
    }

    h2 {
        font-size: rem(30px);
        font-weight: 800;
        text-align: left;
        /* color: #878a94; */
    }

    DIV.table {
        display: table;
        background: white;
        /*box-shadow: 0 5px 6px rgba(0, 0, 0, 0.15);*/
        box-shadow: none;
        padding: 46px 36px;
        border-radius: 5px;
        margin: 0 auto;
        width: 100%;
        min-width: 1200px;
        box-sizing: border-box;
        border-collapse: separate;
        /* color: #878a94; */
        overflow-x: auto;
        table-layout: fixed;
    }

    FORM.tr, DIV.tr {
        display: table-row;
    }

    div.tr {
        border: none;

        &:first-child {
            font-weight: bold;

            > .td {
                border-bottom: 1px solid #005fab;
                padding-bottom: 16px;
                line-height: 18px;
                width: 7%;

                &:first-child {
                    width: 45px;
                }

                &:nth-child(2) {
                    width: 8%;
                }

                &:nth-child(7) {
                    width: 9%;
                }

                &:last-child, &:nth-last-child(2) {
                    width: 40px;
                }

                &:nth-last-child(3) {
                    width: unset;
                }
            }
        }

        > .td {
            border-top: none;
            font-size: rem(14px);
            line-height: 19px;
        }
    }

    SPAN.td {
        display: table-cell;
        border: none;


        &:first-child {
            border-left: none;
        }

        &:last-child {
            border-right: none;

        }
    }

    .controls {
        margin-bottom: 35px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @include media('<1450px') {
            flex-wrap: wrap;
        }

        .button-container {
            padding: 0 15px;
        }

        .buttons {
            display: flex;
            @include media('<1450px') {
                width: 100%;
                justify-content: space-between;
            }
            @include media('<470px') {
                flex-direction: column;
            }

            .adds, .ops {
                display: flex;
                justify-content: space-between;
                @include media('<1200px') {
                    flex-direction: column;
                }
                @include media('<1025px') {
                    flex-direction: row;
                    width: 100%;
                }
                @include media('<776px') {
                    flex-direction: column;
                }

            }

            .adds {
                @include media('<1200px') {
                    align-items: baseline;
                    justify-content: center;
                }
                @include media('<776px') {
                    align-items: baseline;
                    justify-content: center;
                }
            }

            .ops {
                button {
                    @include media('<1200px') {
                        margin: 5px 0;
                    }
                }
            }

        }

        .search-container {
            width: 611px;
            margin-left: 20px;
            @include media('<1450px') {
                width: 100%;
                margin-top: 15px;
                margin-left: 0;
            }
        }

        input {
            border: 1px solid #e5e5e5;
            width: 100%;
            box-sizing: border-box;
            padding: 20px 40px;
            border-radius: 5px;
            margin-left: auto;

        }

        button {
            border: none;
            background: none;
            cursor: pointer;
            color: #005fab;
            font-size: rem(18px);
            font-weight: bold;

            &.cancel, &.save {

                color: white;
                font-size: rem(18px);
                font-weight: bold;
                padding: 12px 50px;
                border-radius: 30px;
                transition: 300ms all ease-in;

            }

            &.save {
                background: #005fab;
                border: 1px solid #005fab;
                margin-left: 60px;
                margin-right: 21px;

                &:hover {
                    color: #005fab;
                    background: white;
                }
            }

            &.cancel {
                background-color: #002678;
                border: 1px solid #002678;

                &:hover {
                    color: #002678;
                    background: white;
                }
            }
        }

        .add-link {
            font-size: rem(18px);
            color: #005fab;
            font-weight: 900;
            line-height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-right: 36px;
            text-align: left;

            a {
                margin-left: 17px;
                text-decoration: none;

                &:active, &:hover, &:visited {
                    color: #005fab;
                }
            }

        }
    }

    .table-container {
        overflow: hidden;
        @include media('<1610px') {
            overflow-x: scroll;
        }
    }

    svg {
        margin-right: 0.5rem;
    }

    button {
        border: none;
        background: none;
        cursor: pointer;
        color: $peacock-blue;
        font-size: rem(18px);
        font-weight: bold;

        &.cancel, &.save {

            color: white;
            font-size: rem(18px);
            font-weight: bold;
            padding: 12px 50px;
            border-radius: 30px;
            transition: 300ms all ease-in;

        }

        &.save {
            background: $peacock-blue;
            border: 1px solid $peacock-blue;

            &:hover {
                color: $peacock-blue;
                background: white;
            }
        }

        &.cancel {
            background-color: $marine-blue;
            border: 1px solid $marine-blue;

            &:hover {
                color: $marine-blue;
                background: white;
            }
        }
    }

    .paging {
        margin-bottom: 35px;

        button {
            margin: 0 15px;
        }
    }

    .validation-error {
        filter: grayscale(100%);
    }

</style>
